module.exports = __webpack_public_path__ + "static/media/grid-item-a16.b743b702.png";